module.exports = __webpack_public_path__ + "static/media/sky-news.dde8b6b9.svg";